import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className="flex items-center gap-2.5 group"
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 transition-transform duration-500 group-hover:rotate-[8deg]"
      >
        <path
          d="M50 14 C32 32, 24 58, 50 86 C76 58, 68 32, 50 14 Z"
          fill="#D49B4B"
        />
        <circle cx="50" cy="50" r="16" stroke="#FAF6F0" strokeWidth="2" fill="none" />
      </svg>
      <span className="font-heading text-lg sm:text-xl leading-none tracking-tight text-plush-text">
        Plush<span className="text-plush-gold italic"> Spa</span>
      </span>
    </Link>
  );
};
